import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Grid, IconButton } from '@chakra-ui/react';
import { EventEmitter, doesSchemaHaveType } from '@progress-fe/core';
import { Svg } from '../../base';
import { Select } from '../../inputs';
import { JsFieldName, JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import * as example from './SelectJsField.example';
/**
 * Component renders "/schemas/jsf-select", "/schemas/jsf-select-arrow", "/schemas/jsf-select-pick-arrow" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is string or number.
 */
const SelectJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const options = props.schema?.oneOf
        ?.map((opt) => {
        const schemaOpt = opt;
        return { value: schemaOpt.const, label: schemaOpt.title, readonly: schemaOpt.readOnly };
    })
        .filter((opt) => opt.value !== null) ?? [];
    const handleChange = (newValue) => {
        props.onChange(doesSchemaHaveType(props.schema, 'number')
            ? Number(newValue?.value)
            : newValue?.value.toString());
    };
    const btn1 = props.isPick || props.isArrow ? '24px' : '';
    const btn2 = props.isPick && props.isArrow ? '24px' : '';
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['string', 'number'], examples: [{ uiSchema: example.UI_SCHEMA, schema: example.SCHEMA, data: example.FORM_DATA }], children: _jsxs(Grid, { pb: props.isPick || props.isArrow ? '1px' : '', "data-testid": "SelectJsField-test", "data-name": props.name, gridTemplateColumns: `minmax(0, 180px) 1fr ${btn1} ${btn2}`, alignItems: "center", gap: "4px", children: [_jsx(JsFieldName, { name: props.schema.title }), _jsx(Select, { name: props.name, options: options, placeholder: "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E", isDisabled: props.readonly, value: options.find((opt) => opt.value === props.formData) || undefined, onChange: (newValue) => {
                        handleChange(newValue);
                    } }, props.formData ? `${props.formData.toString()}` : props.name), props.isPick && (_jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: !props.formData, icon: _jsx(Svg, { size: "s12", name: "Pick" }), onClick: () => {
                        if (typeof props.formData === 'string') {
                            EventEmitter.emit('PickItem', props.formData.toString());
                        }
                    } })), props.isArrow && (_jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: !props.formData, icon: _jsx(Box, { transform: "rotate(180deg)", children: _jsx(Svg, { size: "s12", name: "Back" }) }), onClick: () => {
                        if (typeof props.formData === 'string') {
                            EventEmitter.emit('SelectItem', props.formData.toString());
                        }
                    } }))] }) }));
};
export const SelectJsField = SelectJsFieldFC;
//# sourceMappingURL=SelectJsField.js.map